import Axios from 'axios';

class Shop {
    constructor() {
        this.shopSelectors = document.querySelectorAll('.js-shop-select');
        if (this.shopSelectors.length) {
            this.shopSelectors.forEach((item) => {
                Shop.bind(item);
            });
        }
    }

    static bind(selector) {
        selector.addEventListener('change', (event) => {
            const shopId = parseInt(event.target.value, 10);
            if (shopId) {
                Axios.post('/shop/switch', { shopId }).then((res) => {
                    if (res.data) {
                        window.location.href = res.data;
                    }
                });
            }
        });
    }
}

export default Shop;
